import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

// TODO: Change from Product to Sellable
@Singleton
export default class ProductService extends BaseService {
  async fetch(_companyUuid, { filters, order, pagination, group }) {
    const url = `/v1/optional_groups`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination,
      group
    });
    return await this.get(resourceRoute);
  }

  async fetchByUuid(optionalGroupUuid) {
    return await this.get(`/v1/optional_groups/${optionalGroupUuid}`);
  }

  async update(optionalGroupUuid, params) {
    return await super.update(
      `/v1/optional_groups/${optionalGroupUuid}`,
      params
    );
  }

  async create(params) {
    return await this.post(`/v1/optional_groups`, params);
  }

  async report(params) {
    return await this.get(`/proxy/stitch_app/optionals_report`, params);
  }
}



// WEBPACK FOOTER //
// ./src/core/service/optional-group.service.js